import * as types from '../types';
const showExercise = id => ({
  id,
  type: types.SHOW_EXERCISE
});
export default showExercise;